<ng-container *ngIf="matchScore">

  <div class="match-details-bg" (click)="close()" @opacityInOut></div>
  <div class="match-details" @scaleInOut>
    <div class="match-details__actions">
      <div class="match-details__download">
        <button *ngIf="sourcingType !== SourcingType.External"
          type="button"
          class="match-details__download-btn"
          [class.is-loading]="cvDownloadInProgress"
          (click)="handleDownloadResumeForLiveCandidates()"
          title="{{ 'MatchDetails.DownloadCvTitle' | translate }}">
          <i class="app-ico-mask app-ico-mask__download"></i>
          {{ 'MatchDetails.DownloadCv' | translate }}
        </button>
        <button
          *ngIf="sourcingType === SourcingType.External"
          type="button"
          class="match-details__download-btn"
          [class.is-loading]="cvDownloadInProgress"
          (click)="toggleDownloadMenu($event)"
          title="{{ 'MatchDetails.DownloadCvTitle' | translate }}">
          <i class="app-ico-mask app-ico-mask__download"></i>
          {{ 'MatchDetails.DownloadCv' | translate }}
        </button>
        <div class="match-details__download-menu" *ngIf="showDownloadMenu" @opacityInOut>
          <button type="button" (click)="downloadCv('pdf')" [disabled]="cvDownloadInProgress">
            {{ 'MatchDetails.DownloadPdf' | translate }}
          </button>
        </div>
      </div>
      <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
    </div>
    <div class="match-details__header">
      <!-- <round-progress [score]="matchScore.totalMatch"></round-progress> -->
      <div class="match-details__header__mid">
        <h1>{{ 'MatchDetails.HeaderTitle' | translate }}</h1>
        <div>
          {{ 'MatchDetails.HeaderDescription' | translate }}
        </div>
      </div>
    </div>

    <div class="is-tabs">
      <div class="is-tabs__item" [class.is-tab-active]="currentTab === 'info'" (click)="selectTab('info', true)">
        {{ (isVacancy ? 'MatchDetails.TabVacancy' : 'MatchDetails.TabTalent') | translate }}
      </div>

      <div class="is-tabs__item" [class.is-tab-active]="currentTab === 'hard'" (click)="selectTab('hard', true)">
        {{ 'MatchDetails.TabHard' | translate }}
      </div>
      <div class="is-tabs__item" [class.is-tab-active]="currentTab === 'expectations'"
        (click)="selectTab('expectations', true)">
        {{ 'MatchDetails.TabExpectations' | translate }}
      </div>

    </div>

    <div class="match-details__section is-scroll" *ngIf="currentTab === 'info'">
      <mobile-swipe-hint *ngIf="!touchedSections.includes('info')" (touchstart)="setTouched('info')"
        (click)="setTouched('info')">
      </mobile-swipe-hint>
      <vacancy-talent-info *ngIf="additionalData" [enableScroll]="false" [isVacancy]="isVacancy"
        [data]="additionalData" [vacancySkillNames]="vacancySkillNames" (onAnalyticsEvent)="trackAnalyticsEvent($event)">
      </vacancy-talent-info>
    </div>

    <div class="match-details__section is-scroll" *ngIf="currentTab === 'hard'">
      <div class="match-details__section__header">
        <!-- <round-progress [small]="true" [score]="matchScore.hardSkillsMatch"></round-progress> -->
        <div class="match-details__header__mids">
          <h2>{{ 'MatchDetails.HardSkillsTitle' | translate }}</h2>
          <div>
            {{ 'MatchDetails.HardSkillsDescription' | translate }}
          </div>
        </div>
      </div>

      <div class="match-details__table a-section" *ngIf="hardSkillsCommon">
        <h4>{{ 'MatchDetails.CommonSkills' | translate }}</h4>
        <mobile-swipe-hint *ngIf="!touchedSections.includes('common')" (touchstart)="setTouched('common')"
          (click)="setTouched('common')">
        </mobile-swipe-hint>
        <div class="match-details__table__inner-wrapper">
          <div class="match-details__table__inner">
            <div class="match-details__table__item is-header is-three-cols">
              <div>{{ 'MatchDetails.VacancySkills' | translate }}</div>
              <div>{{ 'MatchDetails.TalentSkills' | translate }}</div>
              <div>{{ 'MatchDetails.VacancyExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.ExpertiseRequired' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpertise' | translate }}</div>
              <div>{{ 'MatchDetails.Matching' | translate }}</div>
            </div>
            <ng-container *ngFor="let branch of hardSkillsCommon">
              <div class="match-details__table__item is-three-cols" *ngFor="let skill of branch.skills">
                <div class="skill-col">
                  <!-- <div class="match-details__table__item__icon">{{ branch.name.substring(0, 1) }}</div> -->
                  <span *ngIf="leastFoundSkills?.includes(skill.name)" class="exclamation-sign"
                    title="Less than 5% of candidates has this skill matching requirements">!</span>
                  {{ skill.name }}
                </div>
                <div>{{ skill.skillMatch ? skill.name : '-' }}</div>
                <div>{{ skill.vacancyExp }}</div>
                <div>{{ skill.talentExp }}</div>
                <div>{{ skill.expertiseRequired }}</div>
                <div>{{ skill.talentExpertise }}</div>
                <div>{{ skill.skillMatch.toFixed() }} %</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="match-details__table a-section" *ngIf="hardSkillsSimilar">
        <h4>{{ 'MatchDetails.SimilarSkills' | translate }}</h4>
        <mobile-swipe-hint *ngIf="!touchedSections.includes('similar')" (touchstart)="setTouched('similar')"
          (click)="setTouched('similar')">
        </mobile-swipe-hint>
        <div class="match-details__table__inner-wrapper">
          <div class="match-details__table__inner">
            <div class="match-details__table__item is-header is-three-cols">
              <div>{{ 'MatchDetails.VacancySkills' | translate }}</div>
              <div>{{ 'MatchDetails.TalentSkills' | translate }}</div>
              <div>{{ 'MatchDetails.VacancyExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpYears' | translate }}</div>
              <div>{{ 'MatchDetails.ExpertiseRequired' | translate }}</div>
              <div>{{ 'MatchDetails.TalentExpertise' | translate }}</div>
              <div>{{ 'MatchDetails.Matching' | translate }}</div>
            </div>
            <ng-container *ngFor="let branch of hardSkillsSimilar">
              <div class="match-details__table__item is-three-cols" *ngFor="let skill of branch.skills">
                <div>{{ skill.name }}</div>
                <div>{{ skill.closeSkillName }}</div>
                <div>{{ skill.vacancyExp }}</div>
                <div>{{ skill.talentExp }}</div>
                <div>{{ skill.expertiseRequired }}</div>
                <div>{{ skill.talentExpertise }}</div>
                <div>{{ skill.skillMatch.toFixed() }} %</div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="match-details__section is-scroll" *ngIf="currentTab === 'expectations'">
      <div class="match-details__section__header">
        <h2>{{ 'MatchDetails.ExpectationsTitle' | translate }}</h2>
      </div>
      <div class="" style="position: relative;">
        <mobile-swipe-hint *ngIf="!touchedSections.includes('expectations')" (touchstart)="setTouched('expectations')"
          (click)="setTouched('expectations')">
        </mobile-swipe-hint>
        <vacancy-talent-details [matchDetails]="matchDetails"></vacancy-talent-details>
      </div>
    </div>


  </div>
</ng-container>
